<template>
  <div class="nav_contant">
    <div class="layout-header">
      <h1>
        <img width="36" height="38" src="../../../../assets/images/logo.png" />
        CFMOTO风控平台
      </h1>

      <el-dropdown class="personal-info" trigger="click" @command="handleMenuClick">
        <span>
          <i class="pr5 el-icon-s-unfold"></i>
          <span>{{ name }}，欢迎你</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="changepwd">修改密码</el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <span style="display: block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <ChangePassword :visiblePassword="visiblePassword" @changeVisiblePassword="changeVisiblePassword"></ChangePassword>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ChangePassword from './ChangePassword.vue';
import envConfig from '@/config';
const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];

export default {
  data() {
    return {
      visiblePassword: false,
    };
  },
  components: {
    ChangePassword,
  },
  created() {},
  mounted() {
    if (this.passwordState) {
      this.visiblePassword = true;
    }
  },
  computed: {
    ...mapState('user', ['name', 'passwordState']),
  },
  methods: {
    changeVisiblePassword(value) {
      this.visiblePassword = value;
    },
    async logout() {
      await this.$confirm('此操作将退出系统, 是否继续?', '退出登录', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      window.location.href = `${baseURL}/riskcontrol/oauth/logout`;
      // this.$message({
      //     type: 'success',
      //     message: '退出成功!'
      // });
    },
    // 修改密码
    updatePassword() {
      this.visiblePassword = true;
    },
    handleMenuClick(command) {
      if (command === 'logout') {
        this.logout();
      } else if (command === 'changepwd') {
        this.updatePassword();
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.nav_contant {
  width: 100%;
  height: 100%;
  position: relative;
}
.layout-header {
  position: fixed;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #fff;
  background: #306bfd;

  h1 {
    position: absolute;
    left: 10px;
    vertical-align: middle;
    font-size: 18px;
    font-weight: normal;
    color: #fff;

    img {
      vertical-align: middle;
      display: inline-block;
      //padding-right: 8px
      max-width: 100%;
    }
  }

  .personal-info {
    position: absolute;
    right: 25px;
    padding: 0 10px;
    font-weight: 600;
    cursor: pointer;
    color: #fff;
  }

  .navbar {
    height: 50px;
    line-height: 50px;
    border-radius: 0px !important;

    .screenfull {
      position: absolute;
      right: 90px;
      top: 16px;
      color: red;
    }
    .avatar-container {
      height: 50px;
      display: inline-block;
      position: absolute;
      right: 35px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 10px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
